import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { IApplicationState } from "../../store";
import { systemMenuToggle } from "../../store/system/slice";
import { Container, Menu, SubMenu } from "./styles";

const SideMenu: React.FC = () => {
  const menuOpen = useSelector(
    (state: IApplicationState) => state.system.menuOpen
  );

  const { t } = useTranslation();

  const { pathname } = useLocation();

  const dispatch = useDispatch();

  return (
    <Container isOpen={menuOpen}>
      <Menu>
        <ul>
          <li className={pathname === "/" ? "active" : ""}>
            <NavLink onClick={() => dispatch(systemMenuToggle(false))} to="/">
              {t("menu.sweeps")}
            </NavLink>
          </li>
          <li className={pathname === "/users" ? "active" : ""}>
            <NavLink
              onClick={() => dispatch(systemMenuToggle(false))}
              to="/users"
              className={({ isActive }) => (!isActive ? "" : "active")}
            >
              {t("menu.users")}
            </NavLink>
          </li>

          <SubMenu className={pathname.startsWith("/settings") ? "open" : ""}>
            <NavLink to="">{t("menu.settings")}</NavLink>

            <ol>
              <li
                className={
                  pathname === "/settings/item-observation" ? "active" : ""
                }
              >
                <NavLink
                  onClick={() => dispatch(systemMenuToggle(false))}
                  to="/settings/item-observation"
                >
                  {t("menu.observations")}
                </NavLink>
              </li>
              <li
                className={pathname === "/settings/item-name" ? "active" : ""}
              >
                <NavLink
                  onClick={() => dispatch(systemMenuToggle(false))}
                  to="/settings/item-name"
                >
                  {t("menu.names")}
                </NavLink>
              </li>
            </ol>
          </SubMenu>
          <li></li>
        </ul>
      </Menu>
    </Container>
  );
};

export default SideMenu;
